import axiosConfig from "./axiosConfig";

interface ActualDemandFromSiteRequest {
  siteId: string;
  esysIdx: number;
  startMonth: string; // "YYYY-MM"
  endMonth: string; // "YYYY-MM"
}

interface ActualDemandFromSiteResponse {
  fileGuid: string;
  fileName: string;
}

const postHhDataTempActualDemandFromSite = async (
  authToken: string,
  request: ActualDemandFromSiteRequest
): Promise<ActualDemandFromSiteResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/actual_demand_from_site`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataTempActualDemandFromSite;
export type { ActualDemandFromSiteRequest, ActualDemandFromSiteResponse };
